import React, { useEffect, useState, useRef } from 'react';
import '../../css/BdStyles.css';
import { useAdminAuth } from '../../../context/AdminAuthContext';
import Cropper from "react-cropper";
import ImageCrop from "../components/ImageCrop";
import "cropperjs/dist/cropper.css";
import { Link, useParams, useNavigate } from 'react-router-dom';
import TagDetailModal from '../components/TagDetailModal';
import RichTextInput from '../components/RichTextInput';
import { API_BASE_URL } from '../scripts/control';
import { ROUTE_PATHS } from '../../../config/constants';
import { dataURLtoBlob } from '../../../utils/dataURLtoBlob';

const BdMovies = () => {
    const { idMovie } = useParams();
    const navigate = useNavigate();
    const { isLoggedIn, isAdmin, login, user } = useAdminAuth();
    const [movies, setMovies] = useState([]);
    const [expanded, setExpanded] = useState({});
    const [editingMovie, setEditingMovie] = useState(null);
    const [deletingMovie, setDeletingMovie] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showCropModal, setShowCropModal] = useState(false);
    const [showConfirmCloseModal, setShowConfirmCloseModal] = useState(false);
    const [croppedImage, setCroppedImage] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [favorites, setFavorites] = useState({});
    const moviesPerPage = 6;
    const [tags, setTags] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);
    const [showTagsModal, setShowTagsModal] = useState(false);
    const [availableTags, setAvailableTags] = useState([]);
    const [searchFilters, setSearchFilters] = useState({
    text: '',
    duration: '',
    durationComparator: '>', // Por defecto '>'
    selectedTags: [],
    });
    const [filteredMovies, setFilteredMovies] = useState([]);
    const [showSearchOptions, setShowSearchOptions] = useState(false);
    const [editingTagDetails, setEditingTagDetails] = useState({});
    const [showTagDetailModal, setShowTagDetailModal] = useState(false);
    const [currentTagForDetail, setCurrentTagForDetail] = useState(null);
    const selectedMovie = idMovie
        ? movies.find(movie => movie.idMovie === parseInt(idMovie, 10))
        : null;
    const [mediaType, setMediaType] = useState('image'); // 'image' o 'video'
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [playingMovieId, setPlayingMovieId] = useState(null);
    const videoRef = useRef(null);
    const pauseTimeoutRef = useRef(null);
    const [movieName, setMovieName] = useState('');
    const [movieYear, setMovieYear] = useState('');
    const [movieAge, setMovieAge] = useState('');
    const [movieDuration, setMovieDuration] = useState('');
    const [img_alt, setImgAlt] = useState('');
    const [img_url, setImgUrl] = useState('');
    const [video_url, setVideoUrl] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeInfo, setActiveInfo] = useState(null);
    const popoverRef = useRef(null);
    const [credits, setCredits] = useState([{ label: '', value: '' }]);
    const [articles, setArticles] = useState([{ label: '', detail: '' }]);
    const [rawImageFile, setRawImageFile] = useState(null);
    const [newSynopsis, setNewSynopsis] = useState('');
    const [newStructure, setNewStructure] = useState('');
    const [editSynopsis, setEditSynopsis] = useState('');
    const [editStructure, setEditStructure] = useState('');
    const totalPages = Math.ceil(filteredMovies.length / moviesPerPage);

     useEffect(() => {
        const fetchMovies = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php?fetchTags=true`);
                const data = await response.json();
                setMovies(data.movies || []);
            } catch (error) {
            }
        };

        fetchMovies();
    }, []);

    useEffect(() => {
        // Aplica los filtros cada vez que cambian
        const applyFilters = () => {
            let filtered = [...movies];
    
            // Filtrar por texto
            if (searchFilters.text) {
                const lowerText = searchFilters.text.toLowerCase();
                filtered = filtered.filter(movie =>
                    movie.movieName.toLowerCase().includes(lowerText) ||
                    movie.movieAge.toString().includes(lowerText) ||
                    movie.movieYear.toString().includes(lowerText) ||
                    movie.tags.some(tag => tag.toLowerCase().includes(lowerText))
                );
            }
    
            // Filtrar por duración
            if (searchFilters.duration) {
                const durationValue = Number(searchFilters.duration);
                if (!isNaN(durationValue)) {
                    filtered = filtered.filter(movie =>
                        searchFilters.durationComparator === '>'
                            ? Number(movie.movieDuration) > durationValue
                            : Number(movie.movieDuration) < durationValue
                    );
                }
            }
    
            // Filtrar por etiquetas seleccionadas
            if (searchFilters.selectedTags.length > 0) {
                filtered = filtered.filter(movie =>
                    searchFilters.selectedTags.every(tag =>
                        movie.tags.includes(tag)
                    )
                );
            }
    
            setFilteredMovies(filtered);
        };
    
        applyFilters();
    }, [movies, searchFilters]);

    useEffect(() => {
    // Solo agrega el listener si hay un popover activo
      if (!activeInfo) return;
    
      const handleClickOutside = (event) => {
        // Si el popover está abierto y el clic es fuera de él...
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
          setActiveInfo(null);
        }
      };
    
      document.addEventListener('click', handleClickOutside);
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }, [activeInfo]);

    // Manejar cambios en los filtros
    const handleFilterChange = (field, value) => {
        setSearchFilters(prevFilters => ({
            ...prevFilters,
            [field]: value,
        }));
    };

    // 1. Obtener las películas y etiquetas juntas
    useEffect(() => {
        const fetchMoviesAndTags = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php?fetchTags=true`);
                const data = await response.json();
    
                if (data.movies && Array.isArray(data.movies)) {
                    // Convertir tags a array (manejar string, array, o valores inválidos)
                    const moviesWithArrayTags = data.movies.map(movie => ({
                        ...movie,
                        tags: Array.isArray(movie.tags) 
                            ? movie.tags 
                            : (typeof movie.tags === 'string' ? movie.tags.split(', ') : [])
                    }));
                    
                    // Ordenar por fecha de creación (más recientes primero)
                    // Si hay created_at, usar eso; si no, usar idMovie como proxy (mayor id = más reciente)
                    const sortedMovies = moviesWithArrayTags.sort((a, b) => {
                        // Intentar ordenar por created_at si existe
                        if (a.created_at && b.created_at) {
                            return new Date(b.created_at) - new Date(a.created_at);
                        }
                        // Si no hay created_at, ordenar por idMovie (mayor id = más reciente)
                        const idA = parseInt(a.idMovie || a.id || 0);
                        const idB = parseInt(b.idMovie || b.id || 0);
                        return idB - idA; // Orden descendente (más reciente primero)
                    });
                    
                    setMovies(sortedMovies);
                }
    
                if (data.tags && Array.isArray(data.tags)) {
                    setTags(data.tags); 
                }
            } catch (error) {
            }
        };
    
        fetchMoviesAndTags();
    }, []);

    useEffect(() => {
      if (currentPage > totalPages) {
        setCurrentPage(1);
      }
    }, [filteredMovies]);


    useEffect(() => {
        if (editingMovie) {
            // Convertir nombres de tags a ids
            const tagIds = editingMovie.tags.map(tagName => {
                const tag = tags.find(t => t.tagName === tagName);
                return tag ? tag.idTag : null;
            }).filter(Boolean);
            setSelectedTags(tagIds);
        }
    }, [editingMovie, tags]);

    const handleCreateNew = () => {
        setShowCreateModal(true);
    };
    const handleConfirmClose = () => {
        setEditingMovie(null);
        setShowCreateModal(null);
        setShowConfirmCloseModal(false);
    };

    const handleCancelClose = () => {
        setShowConfirmCloseModal(false);
            };


    const handleSaveNewMovie = async () => {
      // 1) Recojo todos los campos del formulario
      const imgAlt        = document.getElementById('img_alt').value;
      const movieName     = document.getElementById('newMovieName').value;
      const movieYear     = document.getElementById('newMovieYear').value.trim();
      const movieAge      = document.getElementById('newMovieAge').value;
      const synopsis      = newSynopsis;
      const structure     = newStructure;
      const calOrg        = document.getElementById('newCalOrg').value;
      const calCriterion  = document.getElementById('newCalCriterion').value;
      const supervLevel   = document.getElementById('newSupervLevel').value;
      const movieDuration = document.getElementById('newMovieDuration').value.trim();
    
      // 2) Validaciones básicas
      if (!movieName || !movieAge) {
        alert("Por favor, completa todos los campos obligatorios (Nombre y Clasificación).");
        return;
      }
    
      // 3) Construyo el FormData común
      const formData = new FormData();
      formData.append('tags', JSON.stringify(selectedTags));
      formData.append('tagDetails', JSON.stringify(selectedTags.reduce((acc, id) => {
        acc[id] = editingTagDetails[id] || "";
        return acc;
      }, {})));
      formData.append('movieName', movieName);
      formData.append('movieYear', movieYear);
      formData.append('movieAge', movieAge);
      formData.append('calOrg', calOrg);
      formData.append('calCriterion', calCriterion);
      formData.append('supervLevel', supervLevel);
      formData.append('movieDuration', movieDuration);
      formData.append('synopsis', synopsis);
      formData.append('structure', structure);
      formData.append('credits', JSON.stringify(credits));
      formData.append('articles', JSON.stringify(articles));
      formData.append('img_alt', imgAlt);

      if (croppedImage) {
        formData.append('img_url', croppedImage); // base64
      } else if (selectedVideo) {
        formData.append('video_url', selectedVideo);
      }
    
      try {
        let response;
        if (isAdmin) {
          // 4a) Admin: guardado directo
          formData.append('action', 'create');
          formData.append('contentType', 'película');
          response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php`, {
            method: 'POST',
            body: formData,
          });
          if (!response.ok) {
            alert("Error al guardar la película.");
          } else {
            await response.json();
            alert("Película guardada correctamente.");
            window.location.reload();
          }
        } else {
          // 4b) Usuario NO admin: envía solicitud de creación
          formData.append('action',      'submit_create');
          formData.append('contentType', 'película');
          formData.append('userId',      user.id);
          response = await fetch(`${API_BASE_URL}/api/user_requests.php`, {
            method: 'POST',
            body: formData,
          });
          if (!response.ok) {
            alert("Error al enviar la solicitud.");
          } else {
            alert("Solicitud enviada para su revisión.");
            window.location.reload();
          }
        }
    
      } catch (err) {
        alert("Ocurrió un error. Por favor, inténtalo nuevamente.");
      }
    };


    
        const toggleFavorite = (id) => {
            setFavorites((prevFavorites) => ({
                ...prevFavorites,
                [id]: !prevFavorites[id],
            }));
        };
    
        const handleEdit = (movie) => {
          setMediaType('video');
          setEditingMovie(movie);
          setEditSynopsis(movie.synopsis || '');
          setEditStructure(movie.structure || '');
          setEditingTagDetails({ ...movie.tagsDetails });
          setSelectedVideo(null);
          if (movie.credits) {
              if (typeof movie.credits === 'string') {
                const creditItems = movie.credits
                  .split('||')
                  .map(item => {
                    const parts = item.split('::');
                    return parts.length === 2 ? { label: parts[0], value: parts[1] } : null;
                  })
                  .filter(item => item !== null);
                setCredits(creditItems);
              } else if (Array.isArray(movie.credits)) {
                setCredits(movie.credits);
              }
            } else {
              setCredits([]);
            }
              setShowModal(true);
              if (movie.video_url) {
                setMediaType('video');
              } else {
                setMediaType('image');
              }

        if (movie.articles) {
              if (typeof movie.articles === 'string') {
                const articleItems = movie.articles
                  .split('||')
                  .map(item => {
                    const parts = item.split('::');
                    return parts.length === 2 ? { label: parts[0], value: parts[1] } : null;
                  })
                  .filter(item => item !== null);
                setArticles(articleItems);
              } else if (Array.isArray(movie.articles)) {
                setArticles(movie.articles);
              }
            } else {
              setArticles([]);
            }
              setShowModal(true);
              if (movie.video_url) {
                setMediaType('video');
              } else {
                setMediaType('image');
              }
        };
    
        const handleDelete = (movie) => {
            setDeletingMovie(movie);
        };
    
        const confirmDelete = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: deletingMovie.idMovie }),
            });
    
            if (response.ok) {
                setMovies(movies.filter((movie) => movie.idMovie !== deletingMovie.idMovie));
                setDeletingMovie(null);
            } else {
            }
        } catch (error) {
        }
    };

    const cancelDelete = () => {
        setDeletingMovie(null);
    };

    const handleSave = async () => {
      if (isSubmitting) return;
      setIsSubmitting(true);
      const formData = new FormData();
      const movieName = document.getElementById('movieName').value;
      const movieYear = document.getElementById('movieYear').value;
      const movieAge = document.getElementById('movieAge').value;
      const synopsis = editSynopsis;
      const structure = editStructure;
      const calOrg = document.getElementById('calOrg').value;
      const calCriterion = document.getElementById('calCriterion').value;
      const supervLevel = document.getElementById('supervLevel').value;
      const movieDuration = document.getElementById('movieDuration').value;
      const imgAlt = document.getElementById('img_alt').value;
      
      // Mapear detalles de etiquetas
      const tagDetailsMap = {};
      selectedTags.forEach(tagId => {
        tagDetailsMap[tagId] = editingTagDetails[tagId] || "";
      });
      
      formData.append('tags', JSON.stringify(selectedTags));
      formData.append('tagDetails', JSON.stringify(tagDetailsMap));
      formData.append('idMovie', editingMovie.idMovie);
      formData.append('movieName', movieName);
      formData.append('movieYear', movieYear);
      formData.append('movieAge', movieAge);
      formData.append('synopsis', synopsis);
      formData.append('structure', structure);
      formData.append('calOrg', calOrg);
      formData.append('calCriterion', calCriterion);
      formData.append('supervLevel', supervLevel);
      formData.append('movieDuration', movieDuration);
      formData.append('credits', JSON.stringify(credits));
      formData.append('articles', JSON.stringify(articles));
      
      let response;
      try {
        if (isAdmin) {
          formData.append('action', 'update');
          formData.append('contentType', 'película');
          // Manejar imagen o video para admin (formData)
          if (mediaType === 'image') {
              if (croppedImage) {
                const { blob, ext, isValid } = dataURLtoBlob(croppedImage);
                const filename = rawImageFile?.name || `img_${Date.now()}.${ext}`;
                if (isValid && blob.size > 0) {
                  formData.append('img_url', blob, filename);
                } else if (rawImageFile) {
                  console.warn('Conversión de imagen recortada falló, usando archivo original');
                  formData.append('img_url', rawImageFile, rawImageFile.name);
                }
              } else if (rawImageFile) {
                // si no se recortó, mando el File original
                formData.append('img_url', rawImageFile, rawImageFile.name);
              }
            } else if (mediaType === 'video' && selectedVideo) {
            formData.append('video_url', selectedVideo, selectedVideo.name)
          }
          if (selectedVideo) {
            formData.append('video_url', selectedVideo, selectedVideo.name);
          }
          response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php`, {
            method: 'POST',
            body: formData,
          });
          if (response.ok) {
            const updatedMovie = await response.json();
            // Manejar respuesta exitosa
          } else {
          }
        } else {
          const formDataUser = new FormData();
          formDataUser.append('action', editingMovie ? 'submit_update' : 'submit_create');
          formDataUser.append('contentType', 'película');
          formDataUser.append('target_id', editingMovie ? editingMovie.idMovie : '');
          formDataUser.append('movieName', movieName);
          formDataUser.append('movieYear', movieYear);
          formDataUser.append('movieAge', movieAge);
          formDataUser.append('synopsis', synopsis);
          formDataUser.append('structure', structure);
          formDataUser.append('calOrg', calOrg);
          formDataUser.append('calCriterion', calCriterion);
          formDataUser.append('supervLevel', supervLevel);
          formDataUser.append('movieDuration', movieDuration);
          formDataUser.append('img_alt', imgAlt);
          formDataUser.append('tags', JSON.stringify(selectedTags));
          formDataUser.append('tagDetails', JSON.stringify(tagDetailsMap));
          formDataUser.append('userId', user.id);
          
          if (mediaType === 'image') {
              if (croppedImage) {
                const { blob, ext, isValid } = dataURLtoBlob(croppedImage);
                const filename = rawImageFile?.name || `img_${Date.now()}.${ext}`;
                if (isValid && blob.size > 0) {
                  formDataUser.append('img_url', blob, filename);
                } else if (rawImageFile) {
                  console.warn('Conversión de imagen recortada falló, usando archivo original');
                  formDataUser.append('img_url', rawImageFile, rawImageFile.name);
                }
              } else if (rawImageFile) {
                formDataUser.append('img_url', rawImageFile, rawImageFile.name);
              }
            } else if (mediaType === 'video' && selectedVideo) {
              formDataUser.append('video_url', selectedVideo);
            }

          
          response = await fetch(`${API_BASE_URL}/api/user_requests.php`, {
            method: 'POST',
            body: formDataUser,
          });
        }
      } catch (error) {
        alert("Ocurrió un error. Por favor, inténtalo nuevamente.");
      }
      window.location.reload();
    };




    const handleImageUpload = (e) => {
      const file = e.target.files[0]
      if (!file) return
      setRawImageFile(file)
      const reader = new FileReader()
      reader.onload = () => {
        setSelectedImage(reader.result) 
        setShowCropModal(true)
      }
      reader.readAsDataURL(file)
    }

    const handleCloseModal = () => {
        setShowConfirmCloseModal(true);
    };

    const handleCropSave = (cropped) => {
        setCroppedImage(cropped);
        setShowCropModal(false);
    };

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const indexOfLastMovie = currentPage * moviesPerPage;
    const indexOfFirstMovie = indexOfLastMovie - moviesPerPage;
    const currentMovies = Array.isArray(filteredMovies)
        ? filteredMovies.slice(indexOfFirstMovie, indexOfLastMovie)
        : [];

    const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

    const handleTagChange = (tagId) => {
      if (selectedTags.includes(tagId)) {
        setSelectedTags(selectedTags.filter(id => id !== tagId));
      } else {
        setSelectedTags([...selectedTags, tagId]);
      }
    };

    const handleOpenTagDetail = (tagId) => {
      const tag = tags.find(t => t.idTag === tagId);
      if (tag) {
        setCurrentTagForDetail(tag);
        setShowTagDetailModal(true);
      }
    };

    // Para guardar detalles de las etiquetas
    const handleSaveTagDetail = async (detail) => {
      
      setEditingTagDetails(prev => ({ ...prev, [currentTagForDetail.idTag]: detail }));
    
      // Si se está editando una película (existe editingMovie), se realiza la petición al backend
      if (editingMovie) { 
        const formData = new FormData();
        formData.append('action', 'update_tag_details');
        formData.append('idMovie', editingMovie.idMovie);
        formData.append('idTag', currentTagForDetail.idTag);
        formData.append('details', detail);
    
        try {
          const response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php`, {
            method: 'POST',
            body: formData,
          });
          if (!response.ok) {
          }
        } catch (error) {
        }
      }
    };


    const clearFilters = () => {
        setSearchFilters({
            text: '',
            duration: '',
            durationComparator: '>',
            selectedTags: [],
        });
    };


    const handleMediaUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
        if (mediaType === 'image') {
          // Procesar imagen (usando FileReader y crop)
          const reader = new FileReader();
          reader.onload = () => {
            setSelectedImage(reader.result); // Usado para previsualización y crop
            setShowCropModal(true);
          };
          reader.readAsDataURL(file);
        } else if (mediaType === 'video') {
          setSelectedVideo(file);
          setShowCropModal(false);
          setSelectedImage(null);
        }
      }
    };

    const handleVideoPlay = () => {
      if (pauseTimeoutRef.current) {
        clearTimeout(pauseTimeoutRef.current);
        pauseTimeoutRef.current = null;
      }
    };

    const handleVideoPause = () => {
      pauseTimeoutRef.current = setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.pause();
          videoRef.current.currentTime = 0;
        }
        setPlayingMovieId(null);
      }, 5000);
    };

    const handleVideoEnded = () => {
      setPlayingMovieId(null);
    };

    const handleVideoUpload = (event) => {
      const file = event.target.files[0];
      if (!file) return;
      setSelectedVideo(file);
      setMediaType('video');
    };


    const addCredit = () => {
      setCredits([...credits, { label: '', value: '' }]);
    };

    const addArticle = () => {
      setArticles([...articles, { label: '', detail: '' }]);
    };

    const removeCredit = (index) => {
      const updatedCredits = credits.filter((_, i) => i !== index);
      setCredits(updatedCredits);
    };

    const handleCreditChange = (index, field, value) => {
      const updatedCredits = [...credits];
      updatedCredits[index][field] = value;
      setCredits(updatedCredits);
    };

    const removeArticle = (index) => {
      const updatedArticles = articles.filter((_, i) => i !== index);
      setArticles(updatedArticles);
    };

    const handleArticleChange = (index, field, value) => {
      const updatedArticles = [...articles];
      updatedArticles[index][field] = value;
      setArticles(updatedArticles);
    };


    const handleSaveOrSubmit = async () => {
      const formData = new FormData();
      
      formData.append('movieName', movieName);
      formData.append('movieYear', movieYear);
      formData.append('movieAge', movieAge);
      formData.append('movieDuration', movieDuration);
      formData.append('img_alt', img_alt);
      
      if (mediaType === 'image' && croppedImage) {
        formData.append('img_url', croppedImage);
      } else if (mediaType === 'video' && selectedVideo) {
        formData.append('video_url', selectedVideo, selectedVideo.name);
      }
      
      const tagDetailsMap = {};
      selectedTags.forEach(tagId => {
        tagDetailsMap[tagId] = editingTagDetails[tagId] || "";
      });
      formData.append('tags', JSON.stringify(selectedTags));
      formData.append('tagDetails', JSON.stringify(tagDetailsMap));
      
      if (editingMovie) {
        formData.append('idMovie', editingMovie.idMovie);
      }
      
      try {
        if (isAdmin) {
          // Admin: guardar directamente
          formData.append('action', editingMovie ? 'update' : 'create');
          formData.append('contentType', 'película');
          const response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php`, {
            method: 'POST',
            body: formData,
          });
          if (response.ok) {
            const result = await response.json();
            alert("Película guardada correctamente.");
          } else {
            alert("Error al guardar la película.");
          }
          window.location.reload();
        } else {
          // Usuario: enviar solicitud para revisión (correo)
          formData.append('action', editingMovie ? 'submit_update' : 'submit_create');
          formData.append('contentType', 'película');
          const response = await fetch(`${API_BASE_URL}/api/user_requests.php`, {
            method: 'POST',
            body: formData,
          });
          if (response.ok) {
            alert("Tu solicitud ha sido enviada para revisión.");
          } else {
            alert("Error al enviar la solicitud.");
          }
        }
      } catch (error) {
        alert("Ocurrió un error. Por favor, inténtalo nuevamente.");
      }
      
      window.location.reload();
    };

    return (
    <div className="bd">
    <div className="container">
        <h2 className="title">Películas</h2>
        <hr className="small-hr" />
        <br />
        <div className="search-container">

                <button
                    className="btn btn-outline-primary mb-3"
                    onClick={() => setShowSearchOptions(!showSearchOptions)}
                >Buscar
                    <i className="bi bi-search ms-1"></i>
                </button>

                {showSearchOptions && (
                    <div className="search-options p-3 border rounded bg-white">
                        <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="Buscar por texto..."
                            value={searchFilters.text}
                            onChange={(e) => handleFilterChange('text', e.target.value)}
                        />

                        <select
                            className="form-select mb-2"
                            value={searchFilters.durationComparator}
                            onChange={(e) => handleFilterChange('durationComparator', e.target.value)}
                        >
                            <option value=">">Mayor que</option>
                            <option value="<">Menor que</option>
                        </select>

                        <input
                            type="number"
                            className="form-control mb-2"
                            placeholder="Duración (minutos)"
                            value={searchFilters.duration}
                            onChange={(e) => handleFilterChange('duration', e.target.value)}
                        />

                        <div className="tags-filter">
                            <p>Filtrar por etiquetas:</p>
                            {tags.map(tag => (
                            <div key={tag.idTag}>
                                <input
                                    type="checkbox"
                                    id={`filter-tag-${tag.idTag}`}
                                    checked={searchFilters.selectedTags.includes(tag.idTag)}
                                    onChange={(e) => {
                                        const updatedTags = e.target.checked
                                            ? [...searchFilters.selectedTags, tag.idTag]
                                            : searchFilters.selectedTags.filter(id => id !== tag.idTag);
                                        handleFilterChange('selectedTags', updatedTags);
                                    }}
                                />
                                <label htmlFor={`filter-tag-${tag.idTag}`}>{tag.tagName}</label>
                            </div>
                        ))}
                        </div>

                        <button
                            className="btn btn-primary mt-3 w-100"
                            onClick={() => setShowSearchOptions(false)}
                        >
                            Aplicar filtros
                        </button>
                        <button
                            className="btn btn-secondary mt-2 w-100"
                            onClick={clearFilters}
                        >
                            Limpiar filtros
                        </button>
                    </div>
                )}
            </div>

        {isLoggedIn && (
            <button
                onClick={handleCreateNew}
                style={{
                    marginBottom: '20px',
                    marginLeft: '25%',
                    padding: '10px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                }}
            >
                Crear nueva película
            </button>
        )}

        <div className="row">
            {currentMovies.map((movie, index) => (
            <div key={movie.idMovie || index} className="col-md-4 mb-4">
              <div className={`card ${expanded[movie.idMovie] ? 'expanded' : ''}`}>
                <div className="media-container">
                  {/* Mostrar imagen si existe */}
                  {movie.img_url && (
                    <img
                      src={`${API_BASE_URL}/public/uploads/images/${movie.img_url}`}
                      alt={movie.movieName}
                      className={`media-element ${playingMovieId === movie.idMovie ? 'image-hidden' : 'image-visible'}`}
                      loading="lazy"
                    />
                  )}
                
                  {/* Mostrar video si existe */}
                  {movie.video_url && (
                    <video
                      ref={videoRef}
                      controls
                      autoPlay={playingMovieId === movie.idMovie}
                      preload={playingMovieId === movie.idMovie ? 'auto' : 'none'}
                      onPlay={handleVideoPlay}
                      onPause={handleVideoPause}
                      onEnded={handleVideoEnded}
                      className={`media-element ${playingMovieId === movie.idMovie ? 'video-visible' : 'video-hidden'}`}
                    >
                      <source
                        src={`${API_BASE_URL}/public/uploads/videos/${movie.video_url}`}
                        type="video/mp4"
                      />
                      Tu navegador no soporta el elemento de video.
                    </video>
                  )}
                
                  {/* Botón de play*/}
                  {movie.video_url && playingMovieId !== movie.idMovie && (
                    <button className="play-button" onClick={() => setPlayingMovieId(movie.idMovie)}>
                      &#9658;
                    </button>
                  )}
                </div>
        <div className="card-body">
          <h5 className="card-title">{movie.movieName}</h5>
          <p className="card-text">
            <strong>Año:</strong> {movie.movieYear}
          </p>
          <p className="card-text">
            <strong>Clasificación:</strong> {movie.movieAge} 
            <span
              className="info-icon"
              onClick={(e) => {
                e.stopPropagation();
                setActiveInfo(activeInfo === movie.idMovie ? null : movie.idMovie);
              }}
              style={{ marginLeft: '5px', cursor: 'pointer' }}
            >
              <i className="bi bi-info-circle"></i>
            </span>
          </p>
          {activeInfo === movie.idMovie && (movie.calOrg || movie.calCriterion || movie.supervLevel) && (
               <div ref={popoverRef} className="info-popover">
              {movie.calOrg && (
                <p>
                  <strong>Organismo:</strong> {movie.calOrg}
                </p>
              )}
              {movie.calCriterion && (
                <p>
                  <strong>Criterio:</strong> {movie.calCriterion}
                </p>
              )}
              {movie.supervLevel && (
                <p>
                  <strong>Supervisión:</strong> {movie.supervLevel}
                </p>
              )}
              </div>
            )}
          <p className="card-text">
            <strong>Duración:</strong> {movie.movieDuration}
          </p>
          
          <p className="card-text">
            <strong>Etiquetas:</strong>{' '}
            {Array.isArray(movie.tags)
              ? movie.tags.join(', ')
              : typeof movie.tags === 'string'
              ? movie.tags.split(', ').join(', ')
              : 'Sin etiquetas'}
          </p>
          <Link to={ROUTE_PATHS.DETAIL_LINK.MOVIE(movie.idMovie)} className="btn btn-primary">
            Ver Detalle
          </Link>

          {/* Contenedor para los botones de edición/borrado */}
          <div style={{ marginTop: '10px' }}>
            {isLoggedIn && (
              <button
                onClick={() => handleEdit(movie)}
                style={{
                  marginRight: '10px',
                  padding: '5px 10px',
                  backgroundColor: '#ffc107',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                }}
              >
                Editar
              </button>
            )}
            {isAdmin && (
              <button
                onClick={() => handleDelete(movie)}
                style={{
                  padding: '5px 10px',
                  backgroundColor: '#dc3545',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  color: 'white',
                }}
              >
                Borrar
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  ))}
</div>

<div className="pagination">
  <button className="page-prev" disabled={currentPage === 1} onClick={() => paginate(currentPage-1)}>Anterior</button>
  {pageNumbers.map(n => (
    <button key={n} className={`page-btn ${currentPage===n ? 'active' : ''}`} onClick={() => paginate(n)}>
      {n}
    </button>
  ))}
  <button className="page-next" disabled={currentPage === totalPages} onClick={() => paginate(currentPage+1)}>Siguiente</button>
</div>



{/* Modal de creación de película */}
{showCreateModal && (
  <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Crear Nueva Película</h5>
          <button
            type="button"
            className="btn-close"
            onClick={handleCloseModal}
          ></button>
        </div>
        <div className="modal-body">
          {/* Formulario principal */}
          <form>
            <label htmlFor="newMovieName">Nombre:</label>
            <input type="text" id="newMovieName" />

            <label htmlFor="newMovieYear">Año:</label>
            <input type="text" id="newMovieYear" />

            <label htmlFor="newMovieAge">Clasificación:</label>
            <input type="text" id="newMovieAge" />

            <label htmlFor="newCalOrg">Organismo responsable de la clasificación:</label>
            <input type="text" id="newCalOrg" />

            <label htmlFor="newCalCriterion">Justificación del criterio utilizado:</label>
            <input type="text" id="newCalCriterion" />

            <label htmlFor="newSupervLevel">Nivel de supervisión:</label>

            <select name="justification" id="newSupervLevel">
                <option value=""></option>
                <option value="Autónomo (Apto para ver sin supervisión)">Autónomo (Apto para ver sin supervisión)</option>
                <option value="Acompañado (Ideal para ver y comentar con un adulto)">Acompañado (Ideal para ver y comentar con un adulto)</option>
                <option value="Supervisión necesaria (Incluye temas sensibles)">Supervisión necesaria (Incluye temas sensibles)</option>
            </select>

            <label htmlFor="newMovieDuration">Duración:</label>
            <input type="text" id="newMovieDuration" />

            <label htmlFor="newSynopsis">Sinopsis:</label>
            <RichTextInput
              id="newSynopsis"
              initialContent={newSynopsis}
              onChange={setNewSynopsis}
              placeholder="Sinopsis..."
              style={{ minHeight: '100px' }}
            />

            <label htmlFor="newStructure">Estructura:</label>
            <RichTextInput
              id="newStructure"
              initialContent={newStructure}
              onChange={setNewStructure}
              placeholder="Estructura..."
              style={{ minHeight: '100px' }}
            />

            <div className="credits-section">
              <h4>Créditos</h4>
              {credits.map((credit, index) => (
                <div key={index} className="credit-row">
                  <input
                    type="text"
                    className="credit-label"
                    value={credit.label}
                    onChange={(e) => handleCreditChange(index, 'label', e.target.value)}
                    placeholder="Crédito:"
                  />
                  <input
                    type="text"
                    className="credit-value"
                    value={credit.value}
                    onChange={(e) => handleCreditChange(index, 'value', e.target.value)}
                    placeholder="Persona"
                  />
                  <button type="button" style={{marginLeft: -8}} onClick={() => removeCredit(index)}>
                    x
                  </button>
                </div>
              ))}
              <button type="button" onClick={addCredit}>
                Agregar crédito
              </button>
            </div>

            <div className="credits-section">
              <h4>Artículos relacionados</h4>
              {articles.map((article, index) => (
                <div key={index} className="article-row">
                  <textarea
                    type="resizable-textarea"
                    className="credit-label"
                    value={article.label}
                    onChange={(e) => handleArticleChange(index, 'label', e.target.value)}
                    placeholder="Artículo"
                  /><br></br><br></br>
                  <textarea
                    type="resizable-textarea"
                    className="credit-value"
                    value={article.detail}
                    onChange={(e) => handleArticleChange(index, 'detail', e.target.value)}
                    placeholder="detalles"
                  />
                  <button type="button" style={{marginLeft: 2}} onClick={() => removeArticle(index)}>
                    x
                  </button>
                  <br></br><br></br>
                </div>
              ))}
              <button type="button" onClick={addArticle}>
                Agregar artículo
              </button>
            </div>


            <br></br><br></br>
            {/* Input para imagen */}
            <div>
              <label>Subir imagen:</label>
              <input 
                type="file" 
                accept="image/*" 
                name="img_url"
                onChange={handleImageUpload} 
              />
              {croppedImage && (
                <div className="image-preview mt-3">
                  <p>Previsualización de la imagen recortada:</p>
                  <img src={croppedImage} alt="Imagen recortada" style={{ maxWidth: '100%' }} />
                </div>
              )}
            </div>
            
            {/* Input para video */}
            <div>
              <label>Subir video:</label>
              <input 
                type="file" 
                accept="video/*" 
                name="video_url"
                onChange={handleVideoUpload} 
              />
              {selectedVideo && (
                <div className="video-preview mt-3">
                  <p>Previsualización del video:</p>
                  <video controls style={{ maxWidth: '100%' }}>
                    <source src={URL.createObjectURL(selectedVideo)} type="video/mp4" />
                    Tu navegador no soporta el elemento de video.
                  </video>
                </div>
              )}
            </div>
            <br></br> <br></br>

            <label htmlFor="img_alt">Texto alternativo de la imagen:</label>
            <input type="text" id="img_alt" /><br /><br />

            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={() => setShowTagsModal(true)}
            >
              Seleccionar etiquetas
            </button>
          </form>

          {/* Modal de selección de etiquetas, fuera del form */}
          {showTagsModal && (
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Seleccionar etiquetas</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowTagsModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    {tags.map(tag => (
                      <div key={tag.idTag} className="d-flex align-items-center mb-2">
                        <input
                          type="checkbox"
                          id={`tag-${tag.idTag}`}
                          checked={selectedTags.includes(tag.idTag)}
                          onChange={() => handleTagChange(tag.idTag)}
                          className="me-2"
                        />
                        <label htmlFor={`tag-${tag.idTag}`} className="me-2">
                          {tag.tagName}
                        </label>
                        {selectedTags.includes(tag.idTag) && (
                          <button 
                            className="btn btn-link p-0" 
                            onClick={(e) => {
                              e.preventDefault();
                              handleOpenTagDetail(tag.idTag);
                            }}
                          >
                            <i className="bi bi-gear-fill text-secondary"></i>
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => setShowTagsModal(false)}
                    >
                      Guardar selección
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="modal-footer">
        <button
            type="button"
            className="btn btn-secondary"
            onClick={handleCloseModal}
        >
            Cancelar
        </button>
        {isAdmin && (
          <button type="button" className="btn btn-primary" onClick={handleSaveNewMovie}>
            Guardar película
          </button>
        )}
        {(!isAdmin && isLoggedIn) && (
          <button type="button" className="btn btn-primary" onClick={handleSaveNewMovie}>
            Enviar película
          </button>
        )}
        </div>
      </div>
    </div>
  </div>
)}


        {/* Modal de edición */}
        {editingMovie && (
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Editar Película</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={handleCloseModal}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <label htmlFor="movieName">Nombre:</label>
                                <input type="text" id="movieName" defaultValue={editingMovie.movieName} />
                                <label htmlFor="movieYear">Año:</label>
                                <input type="text" id="movieYear" defaultValue={editingMovie.movieYear} />
                                <label htmlFor="movieAge">Clasificación:</label>
                                <input type="text" id="movieAge" defaultValue={editingMovie.movieAge} />
                                <label htmlFor="calOrg">Organismo responsable de la clasificación:</label>
                                <input type="text" id="calOrg" defaultValue={editingMovie.calOrg} />
                    
                                <label htmlFor="calCriterion">Justificación del criterio utilizado:</label>
                                <input type="text" id="calCriterion" defaultValue={editingMovie.calCriterion} />
                    
                                <label htmlFor="supervLevel">Nivel de supervisión:</label>
                    
                                <select name="justification" id="supervLevel" defaultValue={editingMovie.supervLevel}>
                                    <option value=""></option>
                                    <option value="Autónomo (Apto para ver sin supervisión)">Autónomo (Apto para ver sin supervisión)</option>
                                    <option value="Acompañado (Ideal para ver y comentar con un adulto)">Acompañado (Ideal para ver y comentar con un adulto)</option>
                                    <option value="Supervisión necesaria (Incluye temas sensibles)">Supervisión necesaria (Incluye temas sensibles)</option>
                                </select>
                                <label htmlFor="movieDuration">Duración:</label>
                                <input type="text" id="movieDuration" defaultValue={editingMovie.movieDuration} />
                                <label htmlFor="img_alt">Texto alternativo:</label>
                                <input type="text" id="img_alt" />

                                <label htmlFor="synopsis">Sinopsis:</label>
                                <RichTextInput
                                  id="synopsis"
                                  initialContent={editSynopsis}
                                  onChange={setEditSynopsis}
                                  placeholder="Sinopsis..."
                                  style={{ minHeight: '100px' }}
                                />
                                <label htmlFor="structure">Estructura:</label>
                                <RichTextInput
                                  id="structure"
                                  initialContent={editStructure}
                                  onChange={setEditStructure}
                                  placeholder="Estructura..."
                                  style={{ minHeight: '100px' }}
                                />
                                <div className="credits-section">
                                  <h4>Créditos</h4>
                                  {credits.map((credit, index) => (
                                    <div key={index} className="credit-row">
                                      <input
                                        type="text"
                                        className="credit-label"
                                        value={credit.label}
                                        onChange={(e) => handleCreditChange(index, 'label', e.target.value)}
                                        placeholder="Crédito:"
                                      />
                                      <input
                                        type="text"
                                        className="credit-value"
                                        value={credit.value}
                                        onChange={(e) => handleCreditChange(index, 'value', e.target.value)}
                                        placeholder="Persona"
                                      />
                                      <button type="button" style={{marginLeft: -8}} onClick={() => removeCredit(index)}>
                                        x
                                      </button>
                                    </div>
                                  ))}
                                  <button type="button" onClick={addCredit}>
                                    Agregar crédito
                                  </button>
                                </div>
                                <br /><br />

                                <div className="credits-section">
                                  <h4>Artículos relacionados</h4>
                                  {articles.map((article, index) => (
                                    <div key={index} className="credit-row">
                                      <input
                                        type="text"
                                        className="article-label"
                                        value={article.label}
                                        onChange={(e) => handleArticleChange(index, 'label', e.target.value)}
                                        placeholder="Artículo"
                                      />
                                      <input
                                        type="text"
                                        className="article-detail"
                                        value={article.detail}
                                        onChange={(e) => handleArticleChange(index, 'detail', e.target.value)}
                                        placeholder="Detalle"
                                      />
                                      <button type="button" style={{marginLeft: -8}} onClick={() => removeArticle(index)}>
                                        x
                                      </button>
                                    </div>
                                  ))}
                                  <button type="button" onClick={addArticle}>
                                    Agregar artículo
                                  </button>
                                </div>
                                <br /><br />
                    
                                {/* Input para imagen */}
                                <div>
                                  <label>Subir imagen:</label>
                                  <input 
                                    type="file" 
                                    accept="image/*" 
                                    name="img_url"
                                    onChange={handleImageUpload} 
                                  />
                                  {croppedImage && (
                                    <div className="image-preview mt-3">
                                      <p>Previsualización de la imagen recortada:</p>
                                      <img src={croppedImage} alt="Imagen recortada" style={{ maxWidth: '100%' }} />
                                    </div>
                                  )}
                                </div>
                                
                                {/* Input para video */}
                                <div>
                                  <label>Subir video:</label>
                                  <input 
                                    type="file" 
                                    accept="video/*" 
                                    name="video_url"
                                    onChange={handleVideoUpload} 
                                  />
                                  {selectedVideo && (
                                    <div className="video-preview mt-3">
                                      <p>Previsualización del video:</p>
                                      <video controls style={{ maxWidth: '100%' }}>
                                        <source src={URL.createObjectURL(selectedVideo)} type="video/mp4" />
                                        Tu navegador no soporta el elemento de video.
                                      </video>
                                    </div>
                                  )}
                                </div>
                                  <br></br> <br></br>
                                <div className="modal-header">
                                    <h5 className="modal-title">Seleccionar etiquetas</h5>
                                </div>
                                <div className="modal-body">
                                    {tags.map(tag => (
                                        <div key={tag.idTag} className="d-flex align-items-center mb-2">
                                            <input
                                                type="checkbox"
                                                id={`tag-${tag.idTag}`}
                                                checked={selectedTags.includes(tag.idTag)}
                                                onChange={() => handleTagChange(tag.idTag)}
                                                className="me-2"
                                            />
                                            <label htmlFor={`tag-${tag.idTag}`} className="me-2">
                                                {tag.tagName}
                                            </label>
                                            
                                            {/* Ícono para detalles (solo si el tag está seleccionado) */}
                                            {selectedTags.includes(tag.idTag) && (
                                                <button 
                                                    className="btn btn-link p-0" 
                                                    onClick={(e) => {
                                                        e.preventDefault(); 
                                                        handleOpenTagDetail(tag.idTag)
                                                    }}
                                                >
                                                    <i className="bi bi-gear-fill text-secondary"></i>
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={handleCloseModal}
                                    >
                                        Cancelar
                                    </button>
                                    {isAdmin && (

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleSave}
                                    >
                                        Guardar
                                    </button>
                                    )}
                                    {(!isAdmin && isLoggedIn) && (

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleSave}
                                    >
                                        Enviar
                                    </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
        {/* Modal de confirmación de cierre */}
        {showConfirmCloseModal && (
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmar cierre</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={handleCancelClose}></button>
                        </div>
                        <div className="modal-body">
                            <p>¿Quieres cerrar la ventana? Se perderán los cambios no guardados.</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={handleCancelClose}>Volver</button>
                            <button type="button" className="btn btn-primary" onClick={handleConfirmClose}>Salir</button>
                        </div>
                    </div>
                </div>
            </div>
        )}
        {/* Modal de confirmación de borrado */}
        {deletingMovie && (
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmar borrado</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={cancelDelete}></button>
                        </div>
                        <div className="modal-body">
                            <p>¿Estás seguro de que deseas borrar el artículo {deletingMovie.title}?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={cancelDelete}>Cancelar</button>
                            <button type="button" className="btn btn-danger" onClick={confirmDelete}>Borrar</button>
                        </div>
                    </div>
                </div>
            </div>
        )}
        {/* Modal de recorte */}
        {showCropModal && (
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Recortar Imagen</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShowCropModal(false)}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <ImageCrop image={selectedImage} onImageSave={handleCropSave} />
                        </div>
                    </div>
                </div>
            </div>
        )}
        {showTagDetailModal && currentTagForDetail && (
          <TagDetailModal
            tag={currentTagForDetail}
            initialDetail={editingTagDetails[currentTagForDetail.idTag] || ''}
            onSave={(detail) => {
              handleSaveTagDetail(detail);
            }}
            onClose={() => setShowTagDetailModal(false)}
          />
        )}
        </div>
    </div>
    );
};
export default BdMovies;
